<template>
  <div class="managerNetworkSearchFilter">
    <div class="managerNetworkSearchFilter__firstSection">
      <div class="managerNetworkSearchFilter__firstSection__leftSection">
        <span
          class="btn-router"
          :class="{ 'router-link-active': params.isCorp }"
        >
          기업회원 검색
        </span>

        <span
          class="btn-router"
          :class="{ 'router-link-active': !params.isCorp }"
          @click="onChangeTab"
        >
          개인회원 검색
        </span>
      </div>
      <div class="managerNetworkSearchFilter__firstSection__rightSection">
        <div class="searchInput">
          <input
            type="text"
            placeholder="기업명을 입력하세요."
            v-model="params.name"
          />
        </div>
        <MainButton
          btnText="검색"
          width="74px"
          fontSize="18px"
          @click="handleChangeOption({ name: params.name })"
        />
        <MainButton
          btnText="초기화"
          width="92px"
          fontSize="18px"
          color="red"
          @click="handleChangeOption({ name: '' })"
        />
      </div>
    </div>

    <div class="managerNetworkSearchFilter__lastSection">
      <div style="flex:1">
        <div class="select-option" style="width: 100%">
          <b-form-select
            v-model="params.industryIdx"
            :options="age_friendly_industry"
            @change="onChangeAgeFriendly"
          ></b-form-select>
          <p class="helper">*10대 시니어산업군별 기업 검색</p>
        </div>
      </div>
      <div class="border-column"></div>
      <div style="flex: 1;">
        <div class="select-option" style="width: 100%">
          <b-form-select
            v-model="params.activityIdx"
            :options="hope_activity"
            @change="onChangeHopeActivity"
          ></b-form-select>
          <p class="helper">*고령친화 비즈니스 목표별 검색</p>
        </div>
      </div>
      <div class="border-column"></div>
      <div style="flex: 1; display: flex; gap: 40px;">
        <div class="select-option" style="width: 100%">
          <b-form-select
            v-model="params.companyType"
            :options="companyType_list"
            @change="onChangeCompanyType"
          ></b-form-select>
        </div>

        <div>
          <button class="btn-solid">검색</button>
          <button class="btn-outlined" @click="resetOption">초기화</button>
        </div>
      </div>
    </div>

    <div style="display: flex; justify-content: center; padding-top: 24px;">
      <button class="btn-reset-filter" @click="resetAll">
        전체 검색 초기화
      </button>
    </div>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import { ageFriendlyIndustry, hopeActivity } from "@/data/constances";
import { companyTypeList } from "@/utils/corpUtil";

export default {
  name: "NetworkSearchFilter",
  components: { MainButton },
  props: ["params"],
  data() {
    const obj_age = [{ value: "", text: "매치메이킹 희망 분야" }],
    obj_hope_activity = [{ value: "", text: "매치메이킹 희망 활동" }];

    ageFriendlyIndustry.forEach((ele) => {
      obj_age.push({
        text: ele.name,
        value: ele.value,
      });
    });

    hopeActivity.forEach((ele) => {
      obj_hope_activity.push({
        text: ele.name,
        value: ele.value,
      });
    });
    return {
      age_friendly_industry: obj_age,
      hope_activity: obj_hope_activity,
      companyType_list: companyTypeList,
    };
  },
  mounted() {},
  methods: {
    resetAll() {
      this.handleChangeOption({
        name: "",
        id: "",
        industryIdx: "",
        activityIdx: "",
        companyType: null
      });
    },
    resetOption() {
      this.handleChangeOption({
        id: "",
        industryIdx: "",
        activityIdx: "",
        companyType: null
      });
    },
    onChangeTab() {
      this.handleChangeOption({
        isCorp: false,
        name: "",
        id: "",
        industryIdx: "",
        activityIdx: "",
        companyType: null
      });
    },
    onChangeCompanyType(val) {
      this.handleChangeOption({ companyType: val });
    },
    onChangeAgeFriendly(val) {
      this.handleChangeOption({ industryIdx: val });
    },
    onChangeHopeActivity(val) {
      this.handleChangeOption({ activityIdx: val });
    },
    handleChangeOption(obj) {
      this.$emit("onchange", obj);
    },
  },
};
</script>

<style scoped lang="scss">
.btn-router {
  white-space: nowrap;
  width: 200px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  border-radius: 4px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 2.2rem;
  line-height: 100%;
  letter-spacing: -0.05em;
  color: #a6a6a6;
  height: 46px;
}

.router-link-active {
  background: #26336a;
  color: #fff;
}

.border-column {
  border-left: 1px solid #d6d6d6;
  height: 34px;
}
</style>
